// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#dashboardquery-container .use-bar {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(100% + 30px);
  z-index: 9;
}
#dashboardquery-container .user-rel {
  position: relative;
  left: -10px;
}
#dashboardquery-container .user-rel .use-used {
  visibility: hidden;
  position: absolute;
  left: 16px;
  top: 0;
  z-index: 9;
}
#dashboardquery-container .user-rel:hover .use-used {
  visibility: visible;
  transition: all 0.3s ease-in;
}
#dashboardquery-container .user-available-bar .user-available {
  visibility: hidden;
  position: absolute;
  left: 0px;
  top: 0;
  z-index: 9;
}
#dashboardquery-container .user-available-bar:hover .user-available {
  visibility: visible;
  transition: all 0.3s ease-in;
}
#dashboardquery-container .user-remaining-bar .user-remaining {
  visibility: hidden;
  position: absolute;
  left: 50%;
  top: 0;
  z-index: 9;
}
#dashboardquery-container .user-remaining-bar:hover .user-remaining {
  visibility: visible;
  transition: all 0.3s ease-in;
}
#dashboardquery-container .remain-bar {
  position: absolute;
  left: 0px;
  top: 0;
  width: calc(100% + 0px);
  z-index: 8;
}
#dashboardquery-container .remain-bar-super {
  position: absolute;
  left: 0px;
  top: 0;
  width: calc(100% + 28px);
  z-index: 8;
}
#dashboardquery-container .counter-indi {
  position: absolute;
  top: -36px;
  left: calc(50% - 22px);
  padding: 4px 9px;
  border-radius: 5px;
  white-space: nowrap;
}
#dashboardquery-container .counter-indi .tri {
  top: 23px;
  transform: rotate(180deg);
}
#dashboardquery-container .counter-indi-remain {
  position: absolute;
  top: -36px;
  padding: 4px 9px;
  border-radius: 5px;
  white-space: nowrap;
  right: 0px;
}
#dashboardquery-container .counter-indi-remain .tri {
  top: 23px;
  transform: rotate(180deg);
}
#dashboardquery-container .tri {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 7px solid #eaedf0;
  position: absolute;
  left: 0;
  top: -11px;
  right: 0;
  margin: 0 auto;
}
#dashboardquery-container .middle-counter-indi {
  position: absolute;
  top: -36px;
  left: calc(50% - 22px);
  padding: 4px 9px;
  border-radius: 5px;
  white-space: nowrap;
}
#dashboardquery-container .middle-counter-indi .tri {
  top: 23px;
  transform: rotate(180deg);
}
#dashboardquery-container .dashBoardBorder-dark {
  background-color: #3888ff;
  opacity: 1;
  background-image: linear-gradient(rgba(2, 4, 30, 0.24), rgba(2, 4, 30, 0.24)), linear-gradient(248deg, #297fff, #ae00ff);
  padding: 0.1rem;
  border-radius: 16px;
}
#dashboardquery-container .dashBoardBorder-dark .dashboardQuery-dark {
  background-color: rgba(7, 9, 36, 0.9529411765);
  background-image: linear-gradient(rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03));
  border-radius: 16px;
  padding: 20px;
}
#dashboardquery-container .dashBoardBorder-dark .dashboardQuery-dark:hover {
  background-image: linear-gradient(rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.09));
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/DashboardQuery/DashboardQuery.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,wBAAA;EACA,UAAA;AAAJ;AAEE;EACE,kBAAA;EACA,WAAA;AAAJ;AACI;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,UAAA;AACN;AACI;EACE,mBAAA;EACA,4BAAA;AACN;AAGI;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,UAAA;AADN;AAGI;EACE,mBAAA;EACA,4BAAA;AADN;AAKI;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,UAAA;AAHN;AAKI;EACE,mBAAA;EACA,4BAAA;AAHN;AAME;EACE,kBAAA;EACA,SAAA;EACA,MAAA;EACA,uBAAA;EACA,UAAA;AAJJ;AAME;EACE,kBAAA;EACA,SAAA;EACA,MAAA;EACA,wBAAA;EACA,UAAA;AAJJ;AAME;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAJJ;AAKI;EACE,SAAA;EACA,yBAAA;AAHN;AAME;EACE,kBAAA;EACA,UAAA;EAEA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AALJ;AAMI;EACE,SAAA;EACA,yBAAA;AAJN;AAOE;EACE,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,gCAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,QAAA;EACA,cAAA;AALJ;AAOE;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AALJ;AAMI;EACE,SAAA;EACA,yBAAA;AAJN;AAOE;EACE,yBAAA;EACA,UAAA;EACA,wHAAA;EAKA,eAAA;EACA,mBAAA;AATJ;AAUI;EACE,8CAAA;EACA,uFAAA;EAIA,mBAAA;EACA,aAAA;AAXN;AAaI;EACE,uFAAA;AAXN","sourcesContent":["#dashboardquery-container {\r\n  .use-bar {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: calc(100% + 30px);\r\n    z-index: 9;\r\n  }\r\n  .user-rel {\r\n    position: relative;\r\n    left: -10px;\r\n    .use-used {\r\n      visibility: hidden;\r\n      position: absolute;\r\n      left: 16px;\r\n      top: 0;\r\n      z-index: 9;\r\n    }\r\n    &:hover .use-used {\r\n      visibility: visible;\r\n      transition: all 0.3s ease-in;\r\n    }\r\n  }\r\n  .user-available-bar {\r\n    .user-available {\r\n      visibility: hidden;\r\n      position: absolute;\r\n      left: 0px;\r\n      top: 0;\r\n      z-index: 9;\r\n    }\r\n    &:hover .user-available {\r\n      visibility: visible;\r\n      transition: all 0.3s ease-in;\r\n    }\r\n  }\r\n  .user-remaining-bar {\r\n    .user-remaining {\r\n      visibility: hidden;\r\n      position: absolute;\r\n      left: 50%;\r\n      top: 0;\r\n      z-index: 9;\r\n    }\r\n    &:hover .user-remaining {\r\n      visibility: visible;\r\n      transition: all 0.3s ease-in;\r\n    }\r\n  }\r\n  .remain-bar {\r\n    position: absolute;\r\n    left: 0px;\r\n    top: 0;\r\n    width: calc(100% + 0px);\r\n    z-index: 8;\r\n  }\r\n  .remain-bar-super {\r\n    position: absolute;\r\n    left: 0px;\r\n    top: 0;\r\n    width: calc(100% + 28px);\r\n    z-index: 8;\r\n  }\r\n  .counter-indi {\r\n    position: absolute;\r\n    top: -36px;\r\n    left: calc(50% - 22px);\r\n    padding: 4px 9px;\r\n    border-radius: 5px;\r\n    white-space: nowrap;\r\n    .tri {\r\n      top: 23px;\r\n      transform: rotate(180deg);\r\n    }\r\n  }\r\n  .counter-indi-remain {\r\n    position: absolute;\r\n    top: -36px;\r\n    // left: calc(50% - 0px);\r\n    padding: 4px 9px;\r\n    border-radius: 5px;\r\n    white-space: nowrap;\r\n    right: 0px;\r\n    .tri {\r\n      top: 23px;\r\n      transform: rotate(180deg);\r\n    }\r\n  }\r\n  .tri {\r\n    width: 0;\r\n    height: 0;\r\n    border-left: 5px solid transparent;\r\n    border-right: 5px solid transparent;\r\n    border-bottom: 7px solid #eaedf0;\r\n    position: absolute;\r\n    left: 0;\r\n    top: -11px;\r\n    right: 0;\r\n    margin: 0 auto;\r\n  }\r\n  .middle-counter-indi {\r\n    position: absolute;\r\n    top: -36px;\r\n    left: calc(50% - 22px);\r\n    padding: 4px 9px;\r\n    border-radius: 5px;\r\n    white-space: nowrap;\r\n    .tri {\r\n      top: 23px;\r\n      transform: rotate(180deg);\r\n    }\r\n  }\r\n  .dashBoardBorder-dark {\r\n    background-color: #3888ff;\r\n    opacity: 1;\r\n    background-image: linear-gradient(\r\n        rgba(2, 4, 30, 0.24),\r\n        rgba(2, 4, 30, 0.24)\r\n      ),\r\n      linear-gradient(248deg, #297fff, #ae00ff);\r\n    padding: 0.1rem;\r\n    border-radius: 16px;\r\n    .dashboardQuery-dark {\r\n      background-color: #070924f3;\r\n      background-image: linear-gradient(\r\n        rgba(255, 255, 255, 0.03),\r\n        rgba(255, 255, 255, 0.03)\r\n      );\r\n      border-radius: 16px;\r\n      padding: 20px;\r\n    }\r\n    .dashboardQuery-dark:hover {\r\n      background-image: linear-gradient(\r\n        rgba(255, 255, 255, 0.09),\r\n        rgba(255, 255, 255, 0.09)\r\n      );\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
